<template>
    <div id="connectors-page" class="d-flex align-items-stretch">
        <navigation></navigation>
        <div class="container-fluid main-content page-content">
            <preloader-placeholder :loading="loading" :type="'connector'"></preloader-placeholder>
            <div v-if="loading === false">
                <div class="page-header connectors-page-header" v-if="this.$route.params.welcome">
                    <h3 class="page-title">{{$t('welcome-aboard')}}</h3>
                    <p class="page-subtitle">{{$t('connect-platform-to-cocoapp')}}</p>
                </div>
                <div class="page-header connectors-page-header" v-else>
                    <h3 class="page-title">{{$t('connectors-title')}}</h3>
                    <p class="page-subtitle">{{$t('connectors-text-title')}}</p>
                </div>
                <div class="connectors-list">
                    <connector-box-facebook v-if="facebook.isConnected || !this.$route.params.welcome"></connector-box-facebook>
                    <connector-box-sms v-if="sms.isConnected || !this.$route.params.welcome"></connector-box-sms>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

// Internal components
import ConnectorBoxFacebook from './ConnectorBoxFacebook.vue';
import ConnectorBoxSms      from './ConnectorBoxSms.vue';
import PreloaderPlaceholder from './PreloaderPlaceholder.vue';

// Import external libraries
import {
    mapState,
    mapActions
} from 'vuex';

export default {
    components: {
        ConnectorBoxSms,
        ConnectorBoxFacebook,
        PreloaderPlaceholder
    },

    created () {
        // Get a list of connectors of the current tenant.
        this.getAllConnectors().finally(() => {
            this.loading = false;
        });
    },

    data () {
        return { loading: true };
    },

    computed: {
        ...mapState('core/connectors', [
            'connectors',
            'facebook',
            'sms'
        ])
    },

    methods: {
        ...mapActions('core/connectors', { getAllConnectors: 'index' })
    }
};

</script>
